import { DietIdEnum, DietModeType } from '@front-activerse/common-components';
import { dietSettings } from '@front-activerse/modules';

export const DIET_TYPES_PL = [
  {
    id: 3,
    value: DietIdEnum.DIET_ID_SIMPLE,
    optionTitle: 'app.nutritionSettings.dietType.optionSimple.title',
    optionDescription: 'app.nutritionSettings.dietType.optionSimple.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 5,
    value: DietIdEnum.DIET_ID_INSTANT,
    optionTitle: 'app.nutritionSettings.dietType.optionInstant.title',
    optionDescription: 'app.nutritionSettings.dietType.optionInstant.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 1,
    value: DietIdEnum.DIET_ID_HIGH_PROTEIN,
    optionTitle: 'app.nutritionSettings.dietType.optionHighProtein.title',
    optionDescription: 'app.nutritionSettings.dietType.optionHighProtein.description',
    disableCondition: (values: dietSettings) =>
      values.dietMode === DietModeType.stabilization ||
      values.dietMode === DietModeType.gain_muscle_mass,
    macro: {
      protein: '15-40',
      fat: '25',
      carbs: '35-60',
    },
  },
  {
    id: 2,
    value: DietIdEnum.DIET_ID_ANTY_JOJO,
    optionTitle: 'app.nutritionSettings.dietType.optionAntyJojo.title',
    optionDescription: 'app.nutritionSettings.dietType.optionAntyJojo.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
];

export const DIET_TYPES_CZ = [
  {
    id: 16,
    value: DietIdEnum.DIET_ID_HIGH_PROTEIN,
    optionTitle: 'app.nutritionSettings.dietType.optionHighProtein.title',
    optionDescription: 'app.nutritionSettings.dietType.optionHighProtein.description',
    disableCondition: (values: dietSettings) =>
      values.dietMode === DietModeType.stabilization ||
      values.dietMode === DietModeType.gain_muscle_mass,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 17,
    value: DietIdEnum.DIET_ID_ANTY_JOJO,
    optionTitle: 'app.nutritionSettings.dietType.optionAntyJojo.title',
    optionDescription: 'app.nutritionSettings.dietType.optionAntyJojo.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
];

export const ALL_DIET_TYPES = [...DIET_TYPES_PL, ...DIET_TYPES_CZ];

export const DIET_LEVELS = [
  {
    id: 1,
    value: 'DIET_ID_OXY_CLASSIC',
    optionTitle: 'app.nutritionSettings.dietLevel.dietHighProteinClassic.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietHighProteinClassic.description',
    renderCondition: (values: any) =>
      values.dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN ||
      values.dietType === DietIdEnum.DIET_ID_ANTY_JOJO,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 2,
    value: 'DIET_ID_OXY_VEGE',
    optionTitle: 'app.nutritionSettings.dietLevel.dietHighProteinVege.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietHighProteinVege.description',
    renderCondition: (values: any) =>
      values.dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN ||
      values.dietType === DietIdEnum.DIET_ID_ANTY_JOJO,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 3,
    value: 'DIET_ID_OXY_VEGE_FISH',
    optionTitle: 'app.nutritionSettings.dietLevel.dietHighProteinVegeAndFish.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietHighProteinVegeAndFish.description',
    renderCondition: (values: any) =>
      values.dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN ||
      values.dietType === DietIdEnum.DIET_ID_ANTY_JOJO,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 4,
    value: 'DIET_ID_SIMPLE_CLASSIC',
    optionTitle: 'app.nutritionSettings.dietLevel.dietSimpleClassic.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietSimpleClassic.description',
    renderCondition: (values: any) =>
      values.dietType === DietIdEnum.DIET_ID_SIMPLE ||
      values.dietType === DietIdEnum.DIET_ID_SIMPLE_ANTY_JOJO,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 5,
    value: 'DIET_ID_CLASSIC_SIMPLE_VEGE',
    optionTitle: 'app.nutritionSettings.dietLevel.dietSimpleVege.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietSimpleVege.description',
    renderCondition: (values: any) =>
      values.dietType === DietIdEnum.DIET_ID_SIMPLE ||
      values.dietType === DietIdEnum.DIET_ID_SIMPLE_ANTY_JOJO,
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
];

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
    disableCondition: (values: dietSettings) => values.dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN,
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
    disableCondition: (values: dietSettings) => values.dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN,
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionClassic.title')
// t('app.goalSettings.dietType.optionClassic.description')
// t('app.goalSettings.dietType.optionVeggie.title')
// t('app.goalSettings.dietType.optionVeggie.description')
// t('app.goalSettings.dietType.optionVegan.title')
// t('app.goalSettings.dietType.optionVegan.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')
// t('app.goalSettings.dietType.optionGLP1.title')
// t('app.goalSettings.dietType.optionGLP1.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
